var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('important',{tag:"div",attrs:{"dataAll":{current:_vm.current.components.query,model_style:_vm.current.model_style.query}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }